import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

import extensions from '@utils/loadExtensions'

// @ts-ignore
Vue.use(Vuex)

const extModules = extensions.reduce((acc, ext) => {
  const modules = ext.config.getModules && ext.config.getModules()
  if (modules) {
    acc[ext.namespace] = {
      namespaced: true,
      state: {},
      modules,
    }
  }
  return acc
}, {})

const extPlugins = extensions.reduce((acc, ext) => {
  const p = ext.config.getPlugins && ext.config.getPlugins()
  if (p) {
    acc = acc.concat(p)
  }
  return acc
}, [])

const store = new Vuex.Store({
  modules: {
    ...modules,
    ...extModules,
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: extPlugins,
})

// Automatically run the `init` action for every module,
// if one exists.
for (const moduleName of Object.keys(modules)) {
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`)
  }
}

export default store
